import { render, staticRenderFns } from "./my-partner.vue?vue&type=template&id=d81387a2&scoped=true"
import script from "./my-partner.vue?vue&type=script&lang=js"
export * from "./my-partner.vue?vue&type=script&lang=js"
import style0 from "./my-partner.vue?vue&type=style&index=0&id=d81387a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81387a2",
  null
  
)

export default component.exports